import React from 'react';
import { motion } from 'framer-motion';

// Import images with correct paths
// import scienceIcon from '../../assets/images/home/introStem/sci.png';
// import technologyIcon from '../../assets/images/home/introStem/tec.png';
// import engineeringIcon from '../../assets/images/home/introStem/eng.png';
// import mathIcon from '../../assets/images/home/introStem/mat.png';
// Icons will be referenced directly from public folder

const StemMeaning = () => {
  // Animation variants
  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.2
      }
    }
  };
  
  const itemVariants = {
    hidden: { y: 20, opacity: 0 },
    visible: {
      y: 0,
      opacity: 1,
      transition: {
        duration: 0.5
      }
    }
  };

  return (
    <section id="stem-meaning" className="py-16">
      <div className="container mx-auto px-4">
        <div className="text-center mb-12">
          <h2 className="text-4xl md:text-5xl font-bold mb-2 relative inline-block">
            <span className="text-gray-800">STEM</span> <span className="text-theme-secondary">EDUCATION</span>
          </h2>
          <div className="w-16 h-1 bg-theme-secondary mx-auto mt-2"></div>
        </div>
        
        <motion.div 
          className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 max-w-6xl mx-auto"
          variants={containerVariants}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, amount: 0.3 }}
        >
          {/* Science */}
          <motion.div 
            className="text-center"
            variants={itemVariants}
            whileHover={{ scale: 1.03 }}
            transition={{ type: "spring", stiffness: 300 }}
          >
            <div className="mb-4 inline-block">
              <div className="w-28 h-28 rounded-full bg-theme-red flex items-center justify-center mx-auto">
                <img src="/images/home/introStem/sci.png" alt="Science" className="w-16 h-16 object-contain" />
              </div>
            </div>
            <h4 className="text-xl font-medium uppercase">SCIENCE</h4>
          </motion.div>
          
          {/* Technology */}
          <motion.div 
            className="text-center"
            variants={itemVariants}
            whileHover={{ scale: 1.03 }}
            transition={{ type: "spring", stiffness: 300 }}
          >
            <div className="mb-4 inline-block">
              <div className="w-28 h-28 rounded-full bg-theme-green flex items-center justify-center mx-auto">
                <img src="/images/home/introStem/tec.png" alt="Technology" className="w-16 h-16 object-contain" />
              </div>
            </div>
            <h4 className="text-xl font-medium uppercase">TECHNOLOGY</h4>
          </motion.div>
          
          {/* Engineering */}
          <motion.div 
            className="text-center"
            variants={itemVariants}
            whileHover={{ scale: 1.03 }}
            transition={{ type: "spring", stiffness: 300 }}
          >
            <div className="mb-4 inline-block">
              <div className="w-28 h-28 rounded-full bg-theme-yellow flex items-center justify-center mx-auto">
                <img src="/images/home/introStem/eng.png" alt="Engineering" className="w-16 h-16 object-contain" />
              </div>
            </div>
            <h4 className="text-xl font-medium uppercase">ENGINEERING</h4>
          </motion.div>
          
          {/* Mathematics */}
          <motion.div 
            className="text-center"
            variants={itemVariants}
            whileHover={{ scale: 1.03 }}
            transition={{ type: "spring", stiffness: 300 }}
          >
            <div className="mb-4 inline-block">
              <div className="w-28 h-28 rounded-full bg-theme-light-blue flex items-center justify-center mx-auto">
                <img src="/images/home/introStem/mat.png" alt="Mathematics" className="w-16 h-16 object-contain" />
              </div>
            </div>
            <h4 className="text-xl font-medium uppercase">MATHEMATICS</h4>
          </motion.div>
        </motion.div>
      </div>
    </section>
  );
};

export default StemMeaning; 